import { isNil } from "lodash";
import { trackerApi } from "../../../core/api/TrackerApi";
import { DefaultAutocomplete, DefaultAutocompleteProps } from "../../../core/components/autocomplete/DefaultAutocomplete";
import { useQueryArray } from "../../../core/components/helpers/queryHelper";

export interface SeasonAutocompleteDto {
    id: number,
    name: string
}


const fetchSeasons = async (subCategoryId?: number): Promise<Array<SeasonAutocompleteDto>> => {


    if (isNil(subCategoryId) || isNaN(subCategoryId))
        return []

    const data = await trackerApi.callServiceGet('/oot/generator/seasons/' + subCategoryId)
    return data
}

interface SeasonAutocompleteProps extends DefaultAutocompleteProps<SeasonAutocompleteDto> {
    selection: SeasonAutocompleteDto | null,
    subCategoryId?: number
}

export const SeasonAutocomplete = (props: SeasonAutocompleteProps) => {


    const querySeasonAutocomplete = useQueryArray<SeasonAutocompleteDto>(['/oot/generator/seasons', props.subCategoryId], () => fetchSeasons(props.subCategoryId), 'Season Autocomplete');

    return (
        <DefaultAutocomplete<SeasonAutocompleteDto>
            {...props}
            onChange={props.onChange}
            query={querySeasonAutocomplete}
            displayFieldName='name'
            selection={props.selection}
        />
    )
}